import { Controller } from "@hotwired/stimulus"

// Shows the conflict badge's tooltip in the browser's top layer via the
// native [popover] API so it escapes parent overflow/clip contexts (the table
// wrapper uses overflow-hidden + overflow-y-auto, which clipped the previous
// CSS-only group-hover tooltip).
export default class extends Controller {
  static targets = ["trigger", "content"]

  show() {
    if (!this.hasContentTarget) return

    const rect = this.triggerTarget.getBoundingClientRect()
    this.contentTarget.style.top = `${rect.bottom + 4}px`
    this.contentTarget.style.left = `${rect.left}px`

    if (typeof this.contentTarget.showPopover === "function") {
      try {
        this.contentTarget.showPopover()
      } catch (_e) {
        // Already open — ignore InvalidStateError on rapid hover.
      }
    } else {
      this.contentTarget.classList.remove("hidden")
    }
  }

  hide() {
    if (!this.hasContentTarget) return

    if (typeof this.contentTarget.hidePopover === "function") {
      try {
        this.contentTarget.hidePopover()
      } catch (_e) {
        // Not open — ignore.
      }
    } else {
      this.contentTarget.classList.add("hidden")
    }
  }
}
